import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useIsMobile } from '@/hooks/use-mobile';
import AboutHero from '@/components/about/AboutHero';
import MissionSection from '@/components/about/MissionSection';
import TeamIntroSection from '@/components/about/TeamIntroSection';
import TeamGrid from '@/components/about/TeamGrid';
import CoreValues from '@/components/about/CoreValues';
import ContactCTA from '@/components/about/ContactCTA';
import PageMeta from '@/components/SEO/PageMeta';

const APropos = () => {
  const isMobile = useIsMobile();
  
  const teamMembers = [
    {
      name: "Stephane Dassault",
      role: "Co-Gérant de la Salle des Marchés",
      initials: "SD",
      image: "/lovable-uploads/9f2c43fd-78f0-4fca-bbb7-2d24a8d0f4ec.png"
    },
    {
      name: "Eric Menard",
      role: "Directeur de la Salle des Marchés",
      initials: "EM",
      image: "/lovable-uploads/19db5a7c-a0e6-44dd-9691-f0ec3236d047.png"
    },
    {
      name: "Sophie Lemaire",
      role: "Gestionnaire de Patrimoine Senior",
      initials: "SL",
      image: "/lovable-uploads/a1c4c8cb-de3f-4a5d-a481-62bdfa78fead.png"
    },
    {
      name: "Thomas Dubois",
      role: "Expert en Assurances",
      initials: "TD",
      image: "/lovable-uploads/50189530-bd22-4648-863c-686a389c44a1.png"
    },
    {
      name: "Marie Rousseau",
      role: "Avocate en Droit Fiscal",
      initials: "MR",
      image: "/lovable-uploads/fd524ad0-9793-454a-b135-4bf0b53fa756.png"
    },
    {
      name: "Alexandre Martin",
      role: "Comptable Principal",
      initials: "AM",
      image: "/lovable-uploads/f17a90aa-7018-428f-933f-8ef0b6bd11d0.png"
    },
    {
      name: "Claire Dupont",
      role: "Responsable Marketing",
      initials: "CD",
      image: "/lovable-uploads/71fa1349-d821-4608-bfc5-059851047be7.png"
    },
    {
      name: "Philippe Bernard",
      role: "Analyste Financier",
      initials: "PB",
      image: "/lovable-uploads/94c7ba3a-3488-4aea-929a-b76d26bae881.png"
    },
    {
      name: "Isabelle Moreau",
      role: "Conseillère en Investissements",
      initials: "IM",
      image: "/lovable-uploads/02bd376a-ff86-4d4d-9f9d-5ffb9f86743f.png"
    },
    {
      name: "Laurent Fournier",
      role: "Responsable des Relations Clients",
      initials: "LF",
      image: "/lovable-uploads/ff96e28d-df4c-4b5e-bf2c-5fb3a99abb2a.png"
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <PageMeta 
        title="La Patrimoniale - À Propos, Histoire et Équipe du Cabinet à Paris"
        description="Apprenez tout sur La Patrimoniale, cabinet de gestion de patrimoine à Paris : notre histoire familiale, notre équipe pluridisciplinaire d'experts, nos valeurs éthiques, notre engagement dans le conseil patrimonial sur mesure, notre indépendance et notre réputation depuis plus de 40 ans. Découvrez pourquoi La Patrimoniale s'impose comme la référence pour la gestion de patrimoine à Paris, la transmission, la fiscalité, la protection et l'accompagnement haut de gamme de vos investissements."
        keywords="La Patrimoniale, équipe La Patrimoniale, histoire cabinet gestion patrimoine, expert patrimonial Paris, valeurs La Patrimoniale, indépendant patrimoine, conseil patrimonial, spécialiste gestion patrimoine, expert gestion fortune, gestionnaire patrimoine, contact La Patrimoniale, fondateur La Patrimoniale"
        canonical="https://www.la-patrimoniale-gestion.com/a-propos"
      />
      <Navbar />
      <main className="flex-grow pt-20 md:pt-24">
        <div className={`container mx-auto px-4 md:px-6 ${isMobile ? "py-6" : "py-12"}`}>
          <AboutHero />
          <MissionSection />
          <TeamIntroSection />
          <TeamGrid teamMembers={teamMembers} />
          <CoreValues />
          <ContactCTA />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default APropos;
